export default __webpack_public_path__ + "static/media/NUS_logo.92a3200c.jpg";